// Brand configuration for the build-time brand switch.
//
// The same React app is shipped under two brands:
//   - `ttm`    — Tennis Team Manager (the original; the DEFAULT)
//   - `6love`  — the rebrand at 6love.app, sharing the same backend + database
//
// Selection happens at build time via REACT_APP_BRAND (see ./index.ts). Default
// is `ttm`, so an unset env var reproduces today's app byte-for-byte.

import ttmLogo from '../assets/logo.svg';
import sixLoveMark from '../assets/6love-mark.svg';

export type BrandKey = 'ttm' | '6love';

export interface Brand {
  /** Stable identifier, also used by analytics / debugging. */
  key: BrandKey;
  /** Product name shown in headings, the home-screen prompt, page <title>, etc. */
  name: string;
  /** Abbreviated name for tight spots (e.g. the mobile nav). */
  shortName: string;
  /** Logo/app-mark image (both brands use the green tennis-ball mark). */
  logoSrc: string;
  /** One-line tagline under the logo on the login screen. */
  loginTagline: string;
  /** PWA / browser theme color. */
  themeColor: string;
  /**
   * When true, render the wordmark as the 6love lockup (green "6" + "love")
   * instead of a plain text name. ttm keeps the plain product name.
   */
  useWordmark: boolean;
  /**
   * Whether passkey (WebAuthn) sign-in should be offered. Passkeys are bound to
   * a single domain, so 6love.app starts without them (users would otherwise
   * have to re-register). There is no passkey UI in the app today; this flag is
   * the gate for when one is added.
   */
  showPasskeys: boolean;
}

export const TTM_BRAND: Brand = {
  key: 'ttm',
  name: 'Tennis Team Manager',
  shortName: 'TTM',
  logoSrc: ttmLogo,
  loginTagline: 'Manage your tennis team with ease',
  themeColor: '#18a75b',
  useWordmark: false,
  showPasskeys: true,
};

export const SIXLOVE_BRAND: Brand = {
  key: '6love',
  name: '6-love',
  shortName: '6-love',
  logoSrc: sixLoveMark,
  loginTagline: 'Schedule matches, set availability, build lineups',
  themeColor: '#18a75b',
  useWordmark: true,
  showPasskeys: false,
};
